// help.getbabyplan.com is the public help center: articles and policies only, no account. Any other page
// (sign in, password reset, the app) opens on the app's own domain — the server refuses account requests from
// the help domain. The server does the same for full page loads (apps/server/src/web.ts); this covers links
// followed inside the page.
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

const APP_ORIGIN = (import.meta.env.VITE_APP_ORIGIN as string | undefined) ?? 'https://app.getbabyplan.com';

export const onHelpHost = () => location.hostname.startsWith('help.');
const isPublic = (p: string) => p === '/help' || p.startsWith('/help/') || p.startsWith('/legal/');

export function HelpHostGuard() {
  const { pathname, search } = useLocation();
  const nav = useNavigate();
  useEffect(() => {
    if (!onHelpHost() || isPublic(pathname)) return;
    if (pathname === '/') nav('/help', { replace: true });
    else window.location.replace(`${APP_ORIGIN}${pathname}${search}`);
  }, [pathname, search, nav]);
  return null;
}
